const validations = {
  mustBeNumber: "Este campo debe ser un número",
  mustBePositive: "Este campo debe ser un número positivo",
  required: "Este campo es obligatorio",
  mustBeEmail: "Este campo debe ser un email válido",
  mustBeDate: "Este campo debe ser una fecha válida",
};

export default validations;
